var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { Query } from "react-apollo";
import DefaultLoader from "./Loading/Loader";
import DefaultError from "./Loading/Error";
var LoadingQuery = /** @class */ (function (_super) {
    __extends(LoadingQuery, _super);
    function LoadingQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingQuery.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.Loader, Loader = _b === void 0 ? DefaultLoader : _b, _c = _a.Error, Error = _c === void 0 ? DefaultError : _c, useLoader = _a.useLoader, useError = _a.useError;
        return (React.createElement(Query, __assign({}, this.props), function (apollo) {
            var isLoading = apollo.networkStatus === 4 || apollo.loading;
            if (isLoading && useLoader)
                return React.createElement(Loader, null);
            if (apollo.error && useError)
                return React.createElement(Error, { apollo: apollo });
            return _this.props.children(apollo);
        }));
    };
    LoadingQuery.defaultProps = {
        Error: DefaultError,
        Loader: DefaultLoader,
        useLoader: true,
        useError: true,
        errorHandler: null
    };
    return LoadingQuery;
}(Component));
export default LoadingQuery;
